module.exports = __webpack_public_path__ + "static/media/monument_pin.0584dd87.png";